var _excluded = ["className", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var StarLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.862 21.817a1 1 0 0 1-.411-.978l.98-6.014-4.147-4.251a1 1 0 0 1 .565-1.687l5.691-.87 2.555-5.442a1 1 0 0 1 1.81 0l2.555 5.442 5.691.87a1 1 0 0 1 .565 1.687l-4.148 4.25.981 6.015a1 1 0 0 1-1.47 1.036L12 19.068l-5.079 2.807a1 1 0 0 1-1.06-.058ZM12 17.925l4.449 2.46 1.113.615-.205-1.256-.857-5.256 3.641-3.732.859-.88-1.216-.186-5.003-.765-2.229-4.748L12 3l-.552 1.177-2.23 4.748-5.002.765L3 9.875l.859.88L7.5 14.488l-.857 5.257L6.438 21l1.113-.616L12 17.925Z",
    fill: "currentColor"
  }));
});
StarLg.displayName = "StarLg";
export default StarLg;